import React from 'react';

import BaseBiointelligentLinkFieldModal, {
  BiointelligentLinkFieldModalProps,
} from './BaseBiointelligentLinkFieldModal';

export const TRANSCRIPTION_LINK_NUM_LONGEST_COMPONENTS_TEMPLATE_ID =
  'svdrltmpl_autofilllongesttranscriptions';
export const TRANSCRIPTION_LINK_MAX_LENGTH_TEMPLATE_ID = 'svdrltmpl_autofillmaxtranscriptionlength';
export const TRANSCRIPTION_LINK_MIN_LENGTH_TEMPLATE_ID = 'svdrltmpl_autofillmintranscriptionlength';

export default function TranscriptionLinkFieldModal({
  schemaField,
  onRequestSubmit,
  onRequestClose,
  enableMultiSelectOption,
}: BiointelligentLinkFieldModalProps): JSX.Element {
  return (
    <BaseBiointelligentLinkFieldModal
      schemaField={schemaField}
      componentName="transcriptions"
      residueName="base"
      numLongestComponentsTemplateId={TRANSCRIPTION_LINK_NUM_LONGEST_COMPONENTS_TEMPLATE_ID}
      maxLengthTemplateId={TRANSCRIPTION_LINK_MAX_LENGTH_TEMPLATE_ID}
      minLengthTemplateId={TRANSCRIPTION_LINK_MIN_LENGTH_TEMPLATE_ID}
      onRequestSubmit={onRequestSubmit}
      onRequestClose={onRequestClose}
      enableMultiSelectOption={enableMultiSelectOption}
    />
  );
}
